import { clientbookApi } from '../core/clientbook-api';

/**
 * List reminders from the centralized merchants API.
 * @param {Object} query
 * @param {number} query.limit - Number of results (1–200, default 50)
 * @param {number} query.offset - Number of results to skip (default 0)
 * @param {string[]} [query.statuses] - Filter by status (active, completed, archived, expired)
 * @param {number[]} [query.associateIds] - Filter by associate
 * @param {number[]} [query.storeIds] - Filter by store
 * @param {string} [query.fromDueDate] - YYYY-MM-DD
 * @param {string} [query.toDueDate] - YYYY-MM-DD
 * @param {string[]} [query.sources] - Filter by source (manual, tag, customEvent, salesOpp, lifeEvent, salesTrigger, inquiry)
 * @param {string} [query.sortBy] - dueDate (default), clientName, or source
 * @param {string} [query.sortOrder] - ASC (default) or DESC
 */
export const listReminders = async (query = {}) => {
  return clientbookApi.get({
    url: '/merchants/reminders',
    query,
  });
};

/**
 * Add snake_case aliases so legacy components (MessageConfigToday,
 * InitiateChat, etc.) that read fields like client_id,
 * tag_action_config_id, etc. continue to work with the new camelCase
 * API response.
 *
 */
export const normalizeReminder = reminder => ({
  ...reminder,
  // Client fields that downstream components expect at top level
  client_id: reminder.clientId || reminder.client?.id,
  name: reminder.client?.name,
  store_id: reminder.storeId,
  // Action config IDs used by InitiateChat to determine scope
  custom_event_action_config_id: reminder.customEventActionConfigId,
  life_event_action_config_id: reminder.lifeEventActionConfigId,
  tag_action_config_id: reminder.tagActionConfigId,
  sales_opp_action_config_id: reminder.salesOppActionConfigId,
  // Additional fields for EditReminderModal compatibility
  assigned_to_id: reminder.assignedTo,
  due_date: reminder.dueDate,
  repeat_scale: reminder.repeatScale,
  repeat_interval: reminder.repeatInterval,
});
